/**
 * Vehicle recommendation rails (Milestone 13).
 */

export const RECOMMENDATION_SECTION_KEYS = {
  SIMILAR_MAKE_MODEL: "similar_make_model",
  SIMILAR_BODY_TYPE: "similar_body_type",
  SIMILAR_BUDGET: "similar_budget",
  SAME_DEALER: "same_dealer",
  BETTER_PRICE: "better_price",
  RECENTLY_ADDED: "recently_added",
  FALLBACK_POPULAR: "fallback_popular",
  COMPARE_OPTIONS: "compare_options",
};

export const RECOMMENDATION_SECTION_COPY_ES = {
  [RECOMMENDATION_SECTION_KEYS.SIMILAR_MAKE_MODEL]: {
    title: "Vehículos similares",
    subtitle: "Opciones parecidas por precio, tipo de vehículo y ubicación.",
    reason: "same_make_model",
  },
  [RECOMMENDATION_SECTION_KEYS.SIMILAR_BODY_TYPE]: {
    title: "Mismo tipo de vehículo",
    subtitle: "Compara opciones con carrocería similar en tu ciudad.",
    reason: "same_body_type",
  },
  [RECOMMENDATION_SECTION_KEYS.SIMILAR_BUDGET]: {
    title: "Opciones en tu rango de precio",
    subtitle: "Explora alternativas dentro de un presupuesto parecido.",
    reason: "similar_budget",
  },
  [RECOMMENDATION_SECTION_KEYS.SAME_DEALER]: {
    title: "Más de este concesionario",
    subtitle: "Otros vehículos publicados por el mismo vendedor.",
    reason: "same_dealer",
    ctaLabel: "Ver perfil del concesionario",
  },
  [RECOMMENDATION_SECTION_KEYS.BETTER_PRICE]: {
    title: "Opciones para comparar",
    subtitle:
      "Compara varias opciones antes de decidir. El precio no es el único factor: revisa estado, kilometraje, documentos y disponibilidad.",
    reason: "better_price",
  },
  [RECOMMENDATION_SECTION_KEYS.COMPARE_OPTIONS]: {
    title: "Opciones para comparar",
    subtitle: "Compara antes de decidir.",
    reason: "compare_alternatives",
  },
  [RECOMMENDATION_SECTION_KEYS.RECENTLY_ADDED]: {
    title: "Publicaciones recientes",
    subtitle: "Vehículos agregados o actualizados recientemente.",
    reason: "recently_added",
  },
  [RECOMMENDATION_SECTION_KEYS.FALLBACK_POPULAR]: {
    title: "Vehículos disponibles",
    subtitle: "Explora otras opciones activas en AutoMapa.",
    reason: "fallback_popular",
  },
};

export const RECOMMENDATION_DETAIL_COPY_ES = {
  heading: "Vehículos similares",
  subheading: "Opciones parecidas por precio, tipo de vehículo y ubicación.",
  compareSubheading: "Compara antes de decidir.",
  viewMore: "Ver más vehículos",
  unavailableHeading: "Este vehículo ya no está disponible, pero puedes revisar opciones similares",
  unavailableSubheading: "Explora alternativas activas antes de decidir.",
  viewAvailable: "Ver vehículos disponibles",
  loadError: "No pudimos cargar opciones similares.",
  emptyHidden: true,
  maxSectionsOnDetail: 3,
  maxListingsPerSection: 8,
  maxListingsCompact: 4,
};

export const RECOMMENDATION_ANALYTICS_EVENTS = {
  SECTION_VIEWED: "vehicle_recommendation_section_viewed",
  CARD_CLICKED: "vehicle_recommendation_card_clicked",
  SEARCH_CTA_CLICKED: "vehicle_recommendation_search_cta_clicked",
  SAME_DEALER_CTA_CLICKED: "vehicle_same_dealer_cta_clicked",
  UNAVAILABLE_VIEWED: "vehicle_unavailable_recommendations_viewed",
};

/** Max candidates fetched before client-side scoring. */
export const RECOMMENDATION_CANDIDATE_LIMIT = 48;
